import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@services/auth/auth.service";
import { MenuI, MenuItems } from "src/app/shared/menu-items/menu-items";
import { ToolsService } from "./tools.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(private readonly menuItems: MenuItems, private readonly authService: AuthService, private readonly router:Router, private readonly tools: ToolsService){ }

  async canActivate(raute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    
    let isValidSession = await this.authService.validateSession();

    if (!isValidSession) {
      await this.tools.errorSesionMensaje();
      this.router.navigate(["/"]);
      return false;
    } else {
      return await this.validarRutas(state);
    }  
  }

  async validarRutas(state: any): Promise<boolean> {
    let menus:MenuI[] = this.menuItems.getMenuitem();  
    let UsrInfo = this.authService.getUserInfo();
    let roles: string[] = [];

    for(let menu of menus){      
      if(state.url.endsWith(menu.state)){
        roles = menu.roles;
      }   
      for(let menu1 of menu.content){  
        if(state.url.endsWith(menu1.state)){
          menu1.roles.forEach(element => {
            roles.push(element);
          });          
        }
      }
    }
    
    if(roles.findIndex((rol) => rol === UsrInfo.usuario.nombrePerfil) >= 0){
      return true;
    } else if(roles.findIndex((rol) => rol === 'ANY') >= 0){
        return true;
      } else {
        await this.tools.errorMensaje("No tiene acceso a " + state.url + ", contacte al administrador del sistema.");
        this.router.navigate(["/home"]);
      }
    return false;
  }
}